export default "__VITE_ASSET__B8rTt4pd__"